// SHER-544 guard helpers for the patient lab/images request table.
//
// Route: /patient/:uuidPatient/:action/:typeTest (lab | images).
// Row click used to call `goToSubmissionUrl(uuid, req.submissionPatient.id)`
// directly, which crashed with "Cannot read properties of null (reading 'id')"
// whenever the clicked request had no result submission.
//
// A null `submissionPatient` is NOT corruption: the API populates that relation
// only when a result is filed against the request, so every request is null from
// the moment it is ordered, and imaging/cordonnerie requests are completed
// without a submission at all — there, null is permanent by design. The row is
// simply not openable, so the click must do nothing rather than navigate.

export interface RequestSubmissionNavigationTarget {
    uuidPatient: string;
    idSubmission: number;
}

export interface RequestLike {
    submissionPatient?: { id: number } | null;
    requestsServiceInvestigation?: Array<{
        patientInvestigation?: { uuid?: string };
    }>;
}

/**
 * Returns navigation params for opening a request's submission on the patient
 * lab/images tab, or null when submissionPatient is missing.
 */
export function resolveRequestSubmissionNavigation(
    request: RequestLike | null | undefined
): RequestSubmissionNavigationTarget | null {
    const idSubmission = request?.submissionPatient?.id;
    const uuidPatient =
        request?.requestsServiceInvestigation?.[0]?.patientInvestigation?.uuid;
    if (!uuidPatient || idSubmission == null) {
        return null;
    }
    return { uuidPatient, idSubmission };
}
